import Cookies from 'js-cookie'

const TOKEN_NAME = 'SCMT-ADMIN-TOKEN'

export const setToken = (token, hours) => {
  if (hours) {
    var inFifteenMinutes = new Date(
      new Date().getTime() +  60 * 1000 * 10
    )
    Cookies.set(TOKEN_NAME, token, { expires: inFifteenMinutes })
  } else {
    Cookies.set(TOKEN_NAME, token)
  }
}

export const getToken = () => {
  let token = Cookies.get(TOKEN_NAME)
  return token ? token : ''
}

export const removeToken = () => {
  Cookies.remove(TOKEN_NAME)
}


export const setKey = (key,token, hours) => {
  if (hours) {
    var inFifteenMinutes = new Date(
      new Date().getTime() +  60 * 1000 * 10
    )
    Cookies.set(key, token, { expires: inFifteenMinutes })
  } else {
    Cookies.set(key, token)
  }
}

export const getKey = (key) => {
  let token = Cookies.get(key)
  return token ? token : ''
}

export const removeKey = (key) => {
  Cookies.remove(key)
}

